import React, { useState } from "react";
import { useForm } from "../../../Hooks/UseForm";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumbsGeneric from "../../../components/Nav/BreadCrumbsGeneric";
import debito from "../../../assets/svg/tdc-nacional.svg";
import credito from "../../../assets/svg/tdc-internacional.svg";
import tdcInternacional from "../../../assets/svg/tdc-internacional2.svg";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { UseContextApp } from "../../../Global/Context/appContext";
import {ArrowLeftIcon} from "@heroicons/react/solid";

function TypeDomiciliacion() {

  const location = useLocation();
  const pathName = location.pathname;
  const navigate = useNavigate();
  const [tipoDoc, setTipoDoc] = useState("");
  const [{ user }] = UseContextApp();

  localStorage.setItem('nroCuenta', location.state.data.nroCuenta);
  localStorage.setItem('deudaTotalVEF', location.state.data.deudaTotalVEF);
  localStorage.setItem('ciudadCta', location.state.data.ciudad);

  const typeDomic = (value) => {
    let resTipoDom = "";
    let descripDom = "";
    switch (value) {
      /*case 1:
        resTipoDom = "1";
        setTipoDoc(resTipoDom);
        descripDom = "Débito Nacional";
        localStorage.setItem('descripDom', descripDom);
        navigate('/cuenta/domiciliacion/tipo-instrumento');
        break;
      case 2:
        resTipoDom = "2";
        setTipoDoc(resTipoDom);
        descripDom = "Crédito Nacional";
        localStorage.setItem('descripDom', descripDom);
        navigate('/cuenta/domiciliacion/domiciliacion-credito');
        break;*/
      case 3:
        resTipoDom = "3";
        setTipoDoc(resTipoDom);
        descripDom = "Tarjeta Internacional";
        let url = "https://unonet.xpresspago.com/?cuenta=" + location.state.data.nroCuenta + "&correo=" + user?.datos?.email + "&cedularif=" + user?.datos?.docIdentificacion;
        //window.open(url,"Popup",);

        //window.open(url, "_blank","toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=yes, width=500, height=500, top=200,left=500")
        window.location.href = url;
        break;
    }
  };

  const back = () => {
    navigate('/cuenta/pagos');
  };


  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <div className=" bg-[#f3f4f6] ">
      <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
        <div className="flex lg:w-full gap-5 px-4  flex-col">
          <BreadCrumbsGeneric locations={pathName} />
          <button
                className="bg-white w-[40%] md:w-[10%] h-11 flex justify-center items-center rounded-md shadow px-6  space-x-4"
                onClick={() => back()}
              >
                <div className="flex w-full justify-between items-center">
                  <div>
                    <ArrowLeftIcon className="h-5 w-5" />
                  </div>
                  <div>Volver</div>
                </div>
              </button>
          <div className="bg-white rounded-[10px] py-5 lg:py-0 border-b border-gray-200 lg:px-0 px-6">
            <div className=" py-6 px-6 sm:px-6">
              <div className="py-2 text-2xl font-medium ">
                Domicilia el Pago de tus Servicios
              </div>
              <div className=" text-lg font-regular ">
                Selecciona el instrumento en el que deseas domiciliar el pago de tus servicios.
              </div>
            </div>
            <div className="flex justify-center flex-col md:flex-row items-center gap-5 ">
              {/*<button
                onClick={() => typeDomic(1)}
                className={`
                          w-full
                          justify-center 
                          items-center 
                          ${tipoDoc === "1"
                    ? "border-[#5ab9e5] border-[2px]  "
                    : "border-gray-300 "
                  }
                        h-[162px] 
                        flex-col  
                        relative
                        bg-white 
                        border 
                        rounded-lg
                        hover:border-[#5ab9e5] 
                        lg:w-[30%]    
                        transition-all
                        duration-500 shadow-sm p-4 flex cursor-pointer focus:outline-none`
                }
              >
                {tipoDoc === "1" && (
                  <CheckCircleIcon
                    className="h-7 w-7 absolute right-0 top-0 pt-1 pr-1 text-[#5ab9e5]  "
                    aria-hidden="true"
                  />
                )}

                <img className=" w-[80px] " src={debito} alt="" />
                <div>Débito Nacional</div>
              </button>
              <button
                onClick={() => typeDomic(2)}
                className={`
                          w-full
                          justify-center 
                          items-center 
                          ${tipoDoc === "2"
                    ? "border-[#5ab9e5] border-[2px]  "
                    : "border-gray-300 "
                  }
                        h-[162px] 
                        flex-col  
                        relative
                        bg-white 
                        border 
                        rounded-lg
                        hover:border-[#5ab9e5] 
                        lg:w-[30%]    
                        transition-all
                        duration-500 shadow-sm p-4 flex cursor-pointer focus:outline-none`
                }
              >
                {tipoDoc === "2" && (
                  <CheckCircleIcon
                    className="h-7 w-7 absolute right-0 top-0 pt-1 pr-1 text-[#5ab9e5]  "
                    aria-hidden="true"
                  />
                )}

                <img className=" w-[80px] " src={credito} alt="" />
                <div>Crédito Nacional</div>
              </button>*/}

              <button
                onClick={() => typeDomic(3)}
                className={`
                          w-full
                          justify-center 
                          items-center 
                          ${tipoDoc === "3"
                    ? "border-[#5ab9e5] border-[2px]  "
                    : "border-gray-300 "
                  }
                        h-[162px] 
                        flex-col  
                        relative
                        bg-white 
                        border 
                        rounded-lg
                        hover:border-[#5ab9e5] 
                        lg:w-[30%]    
                        transition-all
                        duration-500 shadow-sm p-4 flex cursor-pointer focus:outline-none`
                }
              >
                {tipoDoc === "3" && (
                  <CheckCircleIcon
                    className="h-7 w-7 absolute right-0 top-0 pt-1 pr-1 text-[#5ab9e5]  "
                    aria-hidden="true"
                  />
                )}

                <img className=" w-[80px] " src={tdcInternacional} alt="" />
                <div>Tarjeta Internacional</div>
              </button>
            </div>
            <div className="bg-white  rounded-md shadow mb-[100px]">
            </div>
          </div>
        </div>
      </div>
    </div>
  );

}
export default TypeDomiciliacion;